var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
    'carousel-arrow',
    { 'carousel-arrow--reverse': _vm.reverse },
    { 'carousel-arrow--disabled': _vm.disabled }
  ],attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('arrow-icon')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }